
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Layout, Share2, Users } from "lucide-react";

const Marketing = () => {
  useEffect(() => {
    console.log("Marketing page component mounted successfully");
  }, []);
  
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">
                EZ Flow Chart
              </h1>
              <p className="text-xl text-gray-600">
                Create beautiful flow charts quickly and easily. Design, collaborate, and 
                visualize your ideas with our intuitive flow chart platform that works even when offline.
              </p>
              <div className="flex flex-wrap gap-4 pt-4">
                <Button asChild size="lg" className="px-6">
                  <Link to="/auth">Get Started <ArrowRight className="ml-2" /></Link>
                </Button>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-xl border">
              <img 
                src="/lovable-uploads/57aab2b8-5601-46fa-826a-878f70e2ddc1.png" 
                alt="Flow Chart Example" 
                className="w-full h-auto" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold mb-4">Why Choose EZ Flow Chart?</h2>
            <p className="text-xl text-gray-600">
              Everything you need to create professional flow charts and bring your ideas to life
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-10">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                <Layout className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Intuitive Interface</h3>
              <p className="text-gray-600">
                Easy-to-use tools that help you create beautiful flow charts in minutes, no training required.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                <Users className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Collaborative Editing</h3>
              <p className="text-gray-600">
                Work together with your team in real-time, with changes syncing instantly across devices.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                <Share2 className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Works Offline</h3>
              <p className="text-gray-600">
                Create and edit flow charts even without an internet connection, with automatic syncing when you're back online.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="container mx-auto max-w-6xl text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-4">Ready to Start Charting?</h2>
            <p className="text-xl text-gray-600 mb-8">
              Join thousands of professionals who use EZ Flow Chart to visualize their processes
            </p>
            <div className="flex gap-4 justify-center">
              <Button asChild size="lg" className="px-8">
                <Link to="/auth">Create Your First Chart</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>

      <footer className="py-10 px-4 bg-gray-100">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <h2 className="text-xl font-bold">EZ Flow Chart</h2>
              <p className="text-gray-600">Create and edit flow diagrams easily</p>
            </div>
            <div className="flex gap-6">
              <Link to="/auth" className="text-gray-600 hover:text-primary">Sign In</Link>
              <a href="#features" className="text-gray-600 hover:text-primary">Features</a>
            </div>
          </div>
          <div className="border-t mt-8 pt-8 text-center text-gray-500">
            <p>&copy; 2025 EZ Flow Chart. All rights reserved.</p>
            <p className="text-sm mt-2">ezflowchart.com</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Marketing;
